import requestv2 from "~/utils/http-v2";

const callSupportApi = {
	gets : async (params) => {
		const url = 'v2/call-support';
		return await requestv2.get(url, {params});
	},
	getByCustomer : async (id) => {
		const url = `v2/call-support/customer/${id}`;
		return await requestv2.get(url);
	},
	add : async (params) => {
		const url = 'v2/call-support';
		return await requestv2.post(url, params);
	}
};

export default callSupportApi;